import React from 'react';

import HaloAxesArcs from 'components/HaloAxesArcs';
import HaloAxesLabels from 'components/HaloAxesLabels';

const HaloAxes = (props) => {
  const { arcAngleCentroid, data, pieSize, radius } = props;

  return (
    <g>
      <HaloAxesArcs count={3} pieSize={pieSize} radius={radius} />
      <HaloAxesLabels
        arcAngleCentroid={arcAngleCentroid}
        count={data.length}
        pieSize={pieSize}
        radius={radius}
      />
    </g>
  )
};

export default HaloAxes;
